export var version = {
  lib: '2.10089.4',
  product: '2.10089.4',
  supportedApiVersion: 2
};



// WEBPACK FOOTER //
// ./src/misc/Version.ts